import { LitElement, html, css } from "lit";

class MatterImage extends LitElement {
  static get styles() {
    return css`
      :host {
        display: block;
        font-family: Source Sans Pro, sans-serif;

        --main-hover: #0b4c1a;
        --main: #087021;
        --main-help: #c4ddca;
        --main-specific-help: #f7fbf8;
        --main-backgroung: #ffffff;

        --grey-main: #333333;
        --grey-help: #bebebe;
        --grey-container: #eeeeee;
        --grey-specific-help: #f5f5f5;

        --status-success: #2abc67;
        --status-info: #5bc0de;
        --status-warning: #f0ad4e;
        --status-error: #d9534f;

        --graph-1: #77b5c3;
        --graph-2: #4863a3;
        --graph-3: #9371ac;
        --graph-4: #d87d7d;
        --graph-5: #d9a46c;
        --graph-6: #e3cd66;
      }
      figure {
        position: relative;
        overflow: hidden;
        margin: 0;
      }

      figure img {
        display: block;
        width: 100%;
        height: 100%;
      }
    `;
  }

  static get properties() {
    return {
      src: { type: String },
      alt: { type: String },
      sizing: { type: String },
      position: { type: String },
      height: { type: String },
      width: { type: String },
      brightness: { type: Number },
    };
  }

  constructor() {
    super();
    this.sizing = "auto";
    this.position = "auto";
    this.src = "";
    this.brightness = 1;
  }

  render() {
    return html`
      <figure>
        <img
          onerror="this.style.display='none'"
          .src="${this.src}"
          .alt="${this.alt}"
          style="${`height: ${this.height}; width: ${this.width}; object-fit: ${this.sizing}; object-position: ${this.position}; filter: brightness(${this.brightness});`}"
        />
        <slot></slot>
      </figure>
    `;
  }
}
if (!window.customElements.get("matter-image")) {
  window.customElements.define("matter-image", MatterImage);
}
